import React from 'react';
import { AnimatedSection } from '../../components/ui/AnimatedSection';
import { Button } from '../../components/ui/Button';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function InsulinResistance() {
  return <main className="w-full pt-32 pb-24 bg-dark min-h-screen" data-id="element-735">
      <article className="max-w-3xl mx-auto px-6" data-id="element-736">
        <AnimatedSection data-id="element-737">
          <Link to="/blog" className="inline-flex items-center text-gold hover:text-white transition-colors mb-8 text-sm font-bold uppercase tracking-wider" data-id="element-738">
            <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-739" />
            Back to Insights
          </Link>

          <div className="mb-12" data-id="element-740">
            <span className="text-gold text-xs font-bold uppercase tracking-wider px-3 py-1 border border-gold/30 rounded-full mb-6 inline-block" data-id="element-741">
              Metabolic Health
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 font-heading leading-tight" data-id="element-742">
              Understanding Insulin Resistance: The Silent Epidemic
            </h1>
            <p className="text-xl text-muted leading-relaxed mb-6" data-id="element-743">
              Why your metabolism might already be struggling even if your labs
              look "normal."
            </p>
            <div className="flex items-center text-sm text-muted font-medium border-t border-border pt-6" data-id="element-744">
              <span data-id="element-745">Oct 12, 2025</span>
              <span className="mx-3" data-id="element-746">•</span>
              <span data-id="element-747">6 min read</span>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2} className="prose prose-invert prose-lg max-w-none prose-headings:font-heading prose-headings:text-white prose-a:text-gold hover:prose-a:text-white prose-strong:text-white" data-id="element-748">
          <p data-id="element-749">
            Most people think their metabolism is "fine" because their blood
            work came back normal. But what if the problem has already
            started... and no one told you?
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-750">
            The Reality Most People Don't See
          </h3>
          <p data-id="element-751">Insulin resistance doesn't appear overnight. It builds slowly.</p>
          <p data-id="element-752">
            You might feel constant fatigue, cravings after meals, difficulty
            losing fat, brain fog, and energy crashes. And yet everything looks
            normal on paper.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-753">
            What's Actually Happening
          </h3>
          <p data-id="element-754">
            Insulin is the hormone that helps your body use energy. When your
            body becomes resistant to it, your cells stop responding properly,
            your body produces more insulin, fat storage increases, and energy
            becomes unstable. This is the beginning of metabolic dysfunction.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-755">
            Why Most People Stay Stuck
          </h3>
          <p data-id="element-756">
            Because they are told to eat less, move more, and trust that
            everything is fine. But insulin resistance is not solved with
            willpower. It's solved by restoring how your body functions.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-757">
            What This Means for You
          </h3>
          <p data-id="element-758">
            If your body holds fat despite effort, feels tired without reason,
            and constantly craves sugar or caffeine, it's not lack of
            discipline. It's a signal.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-759">
            The BioShift Perspective
          </h3>
          <p data-id="element-760">
            We analyze insulin patterns, glucose behavior, lifestyle stressors,
            and metabolic demand to restore function instead of masking
            symptoms.
          </p>
          <p className="text-xl font-medium text-gold italic mt-8" data-id="element-761">
            If this feels familiar, your body is not broken. It can be restored.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-762">
          <div className="mt-16 pt-12 border-t border-border text-center bg-surface p-10 rounded-lg" data-id="element-763">
            <h3 className="text-2xl font-bold text-white mb-4 font-heading" data-id="element-764">
              Ready to restore your metabolic health?
            </h3>
            <p className="text-muted mb-8 max-w-lg mx-auto" data-id="element-765">
              Stop guessing and start fixing the root cause of your symptoms
              with our science-backed approach.
            </p>
            <Button href="https://holistic-health.bioshift.net/calender-booking" size="lg" data-id="element-766">
              Book a Free Health Strategy Call
            </Button>
          </div>
        </AnimatedSection>
      </article>
    </main>;
}